const validate = values => {
	const errors = {};

	if (!values.name) {
		errors.name = "Informe do modelo";
	}

	return errors;
};

export default validate;
